import Swiper from '@/shared/swiper-lite.js';
import {domLoader} from "@/loader.js";
import {initReleaseCountdowns} from "../components/release-countdown.js";

window.swiperInstances = window.swiperInstances || [];

function createSwiper(selector, options) {
  const el = typeof selector === 'string'
    ? document.querySelector(selector)
    : selector;

  if (!el || el.classList.contains('swiper-initialized')) {
    return null;
  }

  const swiper = new Swiper(el, options);
  if (window.swiperInstances) {
    window.swiperInstances.push(swiper);
  }
  return swiper;
}

function bootHomeSwipers() {
  if (!document.querySelector('.home-container')) {
    return;
  }

  initSwipers();
  initPreorderShowcase();
  initProductSwipersBox2();
  initBlogArticles();
}

function initBlogArticles() {
  const el = document.querySelector('.home-blog__swiper');
  if (!el || el.classList.contains('swiper-initialized')) {
    return;
  }

  const section = el.closest('.home-blog');
  if (section) {
    section.classList.remove('wojs');
  }

  createSwiper('.home-blog__swiper', {
    on: {
      click(swiper, event) {
        const target = event.target.closest('a[wire\\:navigate]');
        if (target) {
          target.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          }));
        }
      },
    },
    slidesPerView: 'auto',
    spaceBetween: 14,
    freeMode: true,
  });
}

function initSwipers() {
  try {
    let giftCartSwiper = document.getElementsByClassName('gift-carts-swiper')
    if (giftCartSwiper.length > 0) {
      giftCartSwiper[0].classList.remove('wojs-sm')
      createSwiper(".gift-carts-swiper", {
        on: {
          click(swiper, event) {
            const target = event.target.closest('a[wire\\:navigate]');
            if (target) {
              const simulatedClick = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              target.dispatchEvent(simulatedClick);
            }
          }
        },
        slidesPerView: 5,
        freeMode: true,
        spaceBetween: 32,
        breakpoints: {
          320: {
            slidesPerView: 3.6,
          },

          420: {
            slidesPerView: 4.2,
          },
          550: {
            slidesPerView: 5.8,
          },
          620: {
            slidesPerView: 6.8,
          },
          769: {
            slidesPerView: 7.8,
          },

          1024: {
            slidesPerView: 10.2,
          },
        },
      });
    }

    let sliderSwiper = document.getElementsByClassName('s-swiper')

    if (sliderSwiper.length > 0) {

      // new Swiper(".s-swiper", {
      //   effect: "coverflow",
      //   grabCursor: true,
      //   centeredSlides: true,
      //   slidesPerView: "auto",
      //   coverflowEffect: {
      //     rotate: 50,
      //     stretch: 0,
      //     depth: 100,
      //     modifier: 1,
      //     slideShadows: true,
      //   },
      //
      // });

      createSwiper(".s-swiper", {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 6,
        pagination: {
          clickable: true,
        },
        on: {
          click(swiper, event) {
            // جلوگیری از کلیک تصادفی هنگام اسکرول
            if (!swiper.allowClick) return;

            const target = event.target.closest('a[wire\\:navigate]');
            if (target) {
              target.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
              }));
            }
          }
        }
      });

    }

    // Initialize p-swiper فقط اگر المان وجود داشته باشد
    if (document.querySelector(".p-swiper")) {
      createSwiper(".p-swiper", {
      on: {
        click(swiper, event) {
          const target = event.target.closest('a[wire\\:navigate]');

          if (target) {
            const simulatedClick = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            });
            target.dispatchEvent(simulatedClick);
          }
        }
      },
      slidesPerView: 12,
      spaceBetween: 12,

      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        400: {
          slidesPerView: 2.2,
          spaceBetween: 12,
        },
        600: {
          slidesPerView: 3.2,
          spaceBetween: 12,
        },

        800: {
          slidesPerView: 4,
          spaceBetween: 12,
        },

        1000: {
          slidesPerView: 5,
          spaceBetween: 12,
        },

      },
      pagination: {
        clickable: true,
      },
    });
    }

    // Initialize product-slider فقط اگر المان وجود داشته باشد
    if (document.querySelector(".product-slider")) {
      createSwiper(".product-slider", {
      spaceBetween: 8,
      slidesPerView: 'auto',

      // breakpoints: {
      //   320: { slidesPerView: 1.2, spaceBetween: 8 },
      //   480: { slidesPerView: 1.6, spaceBetween: 10 },
      //   640: { slidesPerView: 2.2, spaceBetween: 12 },
      //   768: { slidesPerView: 3, spaceBetween: 16 },
      //   1024: { slidesPerView: 4, spaceBetween: 20 },
      // },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      on: {
        click(swiper, event) {
          // جلوگیری از کلیک تصادفی هنگام اسکرول
          if (!swiper.allowClick) return;

          const target = event.target.closest('a[wire\\:navigate]');
          if (target) {
            target.dispatchEvent(new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            }));
          }
        }
      }
    });
    }

    // Initialize category-slider فقط اگر المان وجود داشته باشد
    if (document.querySelector(".category-slider")) {
      createSwiper(".category-slider", {

      on: {
        click(swiper, event) {

          const target = event.target.closest('a[wire\\:navigate]');

          if (target) {
            const simulatedClick = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            });
            target.dispatchEvent(simulatedClick);
          }
        }
      },
      slidesPerView: 4,
      spaceBetween: 8,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 8,
        },
        300: {
          slidesPerView: 2,
          spaceBetween: 8,
        },

        440: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
        570: {
          slidesPerView: 4.2,
          spaceBetween: 8,
        },

        640: {
          slidesPerView: 5.1,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 5.8,
          spaceBetween: 8,
        },


      },
    });
    }

    // Initialize blog-slider فقط اگر المان وجود داشته باشد
    if (document.querySelector(".blog-slider")) {
      createSwiper(".blog-slider", {

      on: {
        click(swiper, event) {

          const target = event.target.closest('a[wire\\:navigate]');

          if (target) {
            const simulatedClick = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            });
            target.dispatchEvent(simulatedClick);
          }
        }
      },

      spaceBetween: 8,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
        440: {
          slidesPerView: 2.1,
          spaceBetween: 8,
        },
        570: {
          slidesPerView: 2.8,
          spaceBetween: 8,
        },

        640: {
          slidesPerView: 3.1,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 3.6,
          spaceBetween: 8,
        },
        900: {
          slidesPerView: 4.1,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 4.8,
          spaceBetween: 12,
        },
        1300: {
          slidesPerView: 5.8,
          spaceBetween: 12,
        },
      },
    });
    }


  } catch (e) {
  }
}

function initPreorderShowcase() {
  const showcase = document.querySelector('.preorder-showcase');
  if (!showcase) {
    return;
  }

  initReleaseCountdowns(showcase);

  const swiperEl = showcase.querySelector('#preorder-showcase-swiper');
  if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) {
    return;
  }

  showcase.classList.remove('wojs');

  createSwiper('#preorder-showcase-swiper', {
    on: {
      click(swiper, event) {
        const target = event.target.closest('a[wire\\:navigate]');
        if (target) {
          const simulatedClick = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          });
          target.dispatchEvent(simulatedClick);
        }
      },
    },
    slidesPerView: 'auto',
    spaceBetween: 10,
    freeMode: true,
    breakpoints: {
      768: { spaceBetween: 12 },
      1024: { spaceBetween: 14 },
    },
  });
}

function initProductSwipersBox2() {
  let productBoxSwiper = document.getElementsByClassName('product-box-2-container')
  if (productBoxSwiper.length > 0) {
    for (let i = 0; i < productBoxSwiper.length; i++) {
      let container = productBoxSwiper[i]
      container.classList.remove('wojs')
      let swiper = container.querySelector('.swiper')
      if (!swiper || swiper.classList.contains('swiper-initialized')) {
        continue;
      }

      let id = swiper.getAttribute('id')

      createSwiper("#" + id, {
        on: {
          click(swiper, event) {

            const target = event.target.closest('a[wire\\:navigate]');

            if (target) {
              const simulatedClick = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              target.dispatchEvent(simulatedClick);
            }
          }
        },
        slidesPerView: 5,
        spaceBetween: 8,
        freeMode: true,
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 5,
          },

          320: {
            slidesPerView: 1.8,
            spaceBetween: 5,
          },
          420: {
            slidesPerView: 2.2,
            spaceBetween: 6,
          },
          550: {
            slidesPerView: 2.8,
            spaceBetween: 8,
          },
          620: {
            slidesPerView: 3.6,
            spaceBetween: 8,
          },
          769: {
            slidesPerView: 4.3,
            spaceBetween: 8,
          },

          1024: {
            slidesPerView: 5.2,
            spaceBetween: 8,
          },
        },
      });
    }
  }
}


function destroyAllSwipers() {
  if (window.swiperInstances && window.swiperInstances.length > 0) {
    window.swiperInstances.forEach(swiper => {
      if (swiper && typeof swiper.destroy === 'function') {
        try {
          swiper.destroy(true, true);
        } catch (e) {
          console.warn('Error destroying swiper:', e);
        }
      }
    });
    window.swiperInstances = [];
  }
}

document.addEventListener('livewire:navigating', () => {
  destroyAllSwipers();
});

document.addEventListener('livewire:navigated', () => {
  requestAnimationFrame(() => {
    setTimeout(bootHomeSwipers, 120);
  });
});

domLoader(bootHomeSwipers);
